<button
  [matMenuTriggerFor]="viewSettingsMenu"
  [matTooltip]="labelKey() | translate"
  [attr.aria-label]="labelKey() | translate"
  type="button"
  class="task-view-settings-trigger proffeo-ui-focus-ring"
>
  <mat-icon fontIcon="settings" />
</button>

<mat-menu #viewSettingsMenu="matMenu" panelClass="task-view-settings-menu-panel">
  <div
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    [attr.aria-label]="labelKey() | translate"
    class="task-view-settings-menu flex flex-col px-4 py-3"
  >
    @if (bulkToggle()) {
      <div class="task-view-settings-bulk-toggle">
        <mat-checkbox
          (change)="changeAll($event)"
          [checked]="allEnabled()"
          [indeterminate]="allIndeterminate()"
        >
          <span class="task-view-settings-group-label">
            {{ 'task-details-view-settings.show-hide-all' | translate }}
          </span>
        </mat-checkbox>
      </div>
    }
    @for (section of sections(); track section.key) {
      <div
        [attr.aria-label]="section.labelKey | translate"
        role="group"
        class="task-view-settings-section flex flex-col"
      >
        @if (section.toggleable) {
          <mat-checkbox
            (change)="changeGroup(section.key, $event)"
            [checked]="groupEnabled()[section.key] !== false"
          >
            <span class="task-view-settings-group-label">{{ section.labelKey | translate }}</span>
          </mat-checkbox>
        } @else {
          <p class="task-view-settings-group-label mb-1">
            {{ section.labelKey | translate }}
          </p>
        }
        @if (section.options.length && (!section.toggleable || groupEnabled()[section.key] !== false)) {
          <div
            [class.task-view-settings-options--nested]="section.toggleable"
            class="task-view-settings-options flex flex-col"
          >
            @if (section.kind === 'choice') {
              <mat-radio-group
                (change)="changeChoice(section.key, $event)"
                [value]="values()[section.key]"
                [attr.aria-label]="section.labelKey | translate"
                class="flex flex-col"
              >
                @for (option of section.options; track option.key) {
                  <mat-radio-button [value]="option.key">{{ option.labelKey | translate }}</mat-radio-button>
                }
              </mat-radio-group>
            } @else {
              @for (option of section.options; track option.key) {
                <mat-checkbox
                  (change)="changeToggle(option.key, $event)"
                  [checked]="values()[option.key] === true"
                >
                  {{ option.labelKey | translate }}
                </mat-checkbox>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</mat-menu>
